module.exports = __webpack_public_path__ + "static/img/banner_02.438e7ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pt/banner_02.png
// module id = bGAO
// module chunks = 0